export class PnpService {
  constructor() {
    $pnp.setup({
      sp: {
        headers: {
          Accept: 'application/json; odata=verbose',
        },
      },
    });

    if (!window.location.origin) {
      window.location.origin =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
    }
  }

  getListByTitle(listName, callBack, subsite = '/', filter = null, ...columns) {
    let promise = new $pnp.Web(window.location.origin + subsite);
    promise = promise.lists.getByTitle(listName).items;
    if (filter) promise = promise.filter(filter);
    if (columns && columns.length > 0) promise = promise.select(columns);
    promise.get().then(
      function (list) {
        callBack(list);
      }.bind(this),
    );
  }

  addLogError(title, updateError, error) {
    let promise = new $pnp.Web(window.location.origin + window.CONST.Sharepoint.Subsite);
    promise = promise.lists
      .getByTitle(window.CONST.Sharepoint.List.Logs)
      .items.add({ Title: title, TipoLog: updateError, Detalle: error });
    promise.get();
  }
}
